import Select from 'components/Atoms/Calculator/Select'
import { useTranslation } from 'react-i18next'

interface ThirdStepParticularCarProps {
  setIsDriver: (isDriver: boolean) => void
}

export default function ThirdStepParticularCar({
  setIsDriver,
}: ThirdStepParticularCarProps) {
  const { t } = useTranslation('calculator')
  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col justify-between sm:mt-24 max-sm:gap-6">
        <p>{t('calculator.rightColumn.firstStep.text')}</p>
        <div>
          <p className="font-semibold mb-4">
            {t('calculator.rightColumn.thirdStep.particular.car.labelCTA')}
          </p>
          <div className="flex flex-row gap-4">
            <Select
              text={t(
                'calculator.rightColumn.thirdStep.particular.car.ctaDriver',
              )}
              onClick={() => setIsDriver(true)}
            />
            <Select
              text={t(
                'calculator.rightColumn.thirdStep.particular.car.ctaPassenger',
              )}
              onClick={() => setIsDriver(false)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
